import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import DashboardTemplate from '../../Common/DashboardTemplate';
import PackingSlipDetails from './PackingSlipDetails';
import { ServiceLocator } from '../../../Services/ServiceLocator';
import { AuthenticationService } from '../../../Services/AuthenticationService';
import { followAppLink } from '../../../utils/appLink';

const tileStyle = {
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginBottom: 0,
    marginTop: 15,
};

function ViewPackingSlip(props) {
    const packingSlipId = props.match?.params?.packingSlipId;
    const history = props.history;
    const [loading, setLoading] = useState(true);
    const [parts, setParts] = useState([]);
    const [partFamilies, setPartFamilies] = useState([]);
    const [packingSlips, setPackingSlips] = useState([]);

    useEffect(() => {
        const user = AuthenticationService.getInstance().getUser();
        if (!user) {
            history.push('/login');
            return undefined;
        }
        let cancelled = false;
        const partService = ServiceLocator.Instance.getPartService();
        Promise.all([
            partService.getAllPartsExpanded(),
            partService.getPartFamilies(),
            partService.getAllPackingSlips(),
        ]).then(([loadedParts, loadedFamilies, loadedSlips]) => {
            if (cancelled) return;
            setParts(loadedParts || []);
            setPartFamilies(loadedFamilies || []);
            setPackingSlips(loadedSlips || []);
            setLoading(false);
        }).catch(() => {
            if (!cancelled) setLoading(false);
        });
        return () => { cancelled = true; };
    }, [history]);

    const goToList = (event) => followAppLink(history, '/admin/packing-slips', event);

    const openEditDrawer = (slip, event) => {
        const url = `/admin/packing-slips?edit=${encodeURIComponent(slip.id)}`;
        followAppLink(history, url, event);
    };

    const openDuplicate = (duplicationData) => {
        history.push({ pathname: '/admin/packing-slips', state: { duplicatePackingSlip: duplicationData } });
    };

    return (
        <DashboardTemplate title="Packing Slip">
            <div className="main-dashboard-root">
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
                    <Button variant="outlined" className="success-button-lg" onClick={goToList}>
                        Back to Packing Slips
                    </Button>
                </div>
                {loading ? (
                    <div className="container" style={{ maxWidth: 1600, ...tileStyle }}>
                        <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                    </div>
                ) : (
                    <div className="container" style={tileStyle}>
                        <PackingSlipDetails
                            asPage
                            open
                            packingSlipId={packingSlipId}
                            onClose={goToList}
                            onRequestEdit={openEditDrawer}
                            onRequestDuplicate={openDuplicate}
                            onUpdate={() => {}}
                            parts={parts}
                            partFamilies={partFamilies}
                            packingSlips={packingSlips}
                        />
                    </div>
                )}
            </div>
        </DashboardTemplate>
    );
}

ViewPackingSlip.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
};

export default ViewPackingSlip;
